import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from "./Footer";
import Header from "./Header";
import 'flatpickr/dist/flatpickr.min.css';
import ErrorImg from './assets/img/ErrorImg.png';


const EnterVerificationCode = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true); // Default to open

    const [code, setCode] = useState(["", "", "", ""]);

    const handleInputChange = (value, index) => {
        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        // Automatically focus the next input field
        if (value && index < code.length - 1) {
            document.getElementById(`code-input-${index + 1}`).focus();
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !code[index] && index > 0) {
            document.getElementById(`code-input-${index - 1}`).focus();
        }
    };

    return (
        <>
            <Header></Header>
            <div className="mainContent enterVerCodeWrap">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="itemWrap">
                            <h2>Enter Verification code</h2>
                            <p>We sent a 4-digit code to ******05</p>
                            <div className="inputFieldWrap">
                                {code.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`code-input-${index}`}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleInputChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                    />
                                ))}
                            </div>
                            <a className="btn" href="/ManageBooking">CONTINUE</a>
                            <p className="resendCode"> Didn’t receive the email? <a href="#">Resend</a> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer></Footer>
        </>
    );
}
export default EnterVerificationCode;